import { ReadLastAd } from "../../utils/FuncAd";

const Default =  {
    onSetValue : () => {},
}

/**
 * Class de gestion des inputs de type codepub
 */
class InputCodePub {

    /**
     * Constructeur de la class
     * @param target    Element cible
     * @param options
     */
    constructor (target, options = {}) {
        this._target = target
        this._options = { ...Default, ...options}
        this._init()
    }

    /**
     * Initialisation
     * @private
     */
    _init () {
        this.setValue()
    }

    /**
     * Assigne la valeur à l'input
     */
    setValue () {
        this._target.value = ReadLastAd()
        this._options.onSetValue()
    }
}

if(typeof window !== "undefined") {
    window.InputCodePub = InputCodePub
}

/**
 * Initialisation du code pub pour les inputs ayant le name codepub ou les
 * inputs ayant un attribute data-input="codepub"
 */
export function initInputCodePub () {
    ['input[name="CODEPUB"]', 'input[name="codepub"]', 'input[data-input="codepub"]'].forEach(selector => {
        document.querySelectorAll(selector).forEach(target => {
            new InputCodePub(target)
        })
    })
}

export default InputCodePub
